import React, { useState, useEffect } from "react";

import { useQuery, useMutation } from "react-apollo";

import { Field, Control, Label, Column } from "rbx";
import PropTypes from "prop-types";
import {
  ALL_SYSTEM_CODES_QUERY,
  UPDATE_SYSTEM_CODE_MUTATION
} from "../../../../../graphql/SystemCodes/SystemCodes.graphql";

import { BooleanInput } from "../../../../../components/inputs";

import Loading from "../../../../../components/Loading";

import { ourToast as toast } from "../../../../../utils";

import "./CalcTypeUsage.scss";

const CalcTypeUsage = ({ inputs, onChange, disabled = false }) => {
  const CompanyId = window.localStorage.getItem("user_company");
  const [state, setState] = useState({});

  const { data, loading } = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {
        CompanyId,
        Type: "System",
        CodeName: "CalcType"
      }
    }
  });
  const [updateSystemCode] = useMutation(UPDATE_SYSTEM_CODE_MUTATION, {
    refetchQueries: ["ALL_SYSTEM_CODES_QUERY"]
  });

  const handleChange = async (recId, value) => {
    try {
      await updateSystemCode({
        variables: {
          data: {
            Active: value
          },
          where: {
            RecId: parseInt(recId)
          }
        }
      });
      toast.success(`Calc Type ${value ? "" : "in"}activated.`);
    } catch (err) {
      toast.error("Error activating Calc Type.");
    }
  };

  useEffect(() => {
    if (data && Array.isArray(data.SystemCodes)) {
      const updates = data.SystemCodes.reduce((acc, curr) => {
        acc[curr.RecId] = !!curr.Active;
        return acc;
      }, {});
      setState(updates);
    }
  }, [data]);

  if (loading || !data || !Array.isArray(data.SystemCodes)) {
    return <Loading />;
  }
  return (
    <Field multiline kind="group">
      <Column size={4}>
        <Column.Group>
          <Column size={3}>
            <Control>
              <BooleanInput
                disabled={disabled}
                name="AllowMaintenanceBilling"
                value={inputs.AllowMaintenanceBilling}
                onChange={onChange}
              />
            </Control>
          </Column>
          <Column size={9}>
            <Label style={{ flex: "none", marginTop: 5 }}>
              Allow Work Order Billing
            </Label>
          </Column>
        </Column.Group>
      </Column>
      {data.SystemCodes.map((code, key) => (
        <Column key={key} size={4}>
          <Column.Group>
            <Column size={3}>
              <Control key={key}>
                <BooleanInput
                  disabled={disabled}
                  name={code.RecId}
                  value={state[code.RecId]}
                  onChange={({ target: { checked } }) =>
                    handleChange(code.RecId, checked)
                  }
                />
              </Control>
            </Column>
            <Column size={9}>
              <Label style={{ flex: "none", marginTop: 5 }}>
                {code.CodeDescription}
              </Label>
            </Column>
          </Column.Group>
        </Column>
      ))}
    </Field>
  );
};

CalcTypeUsage.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default CalcTypeUsage;
